import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import {
  useAPIGetPSPegawaiNotificationList,
  useAPIMarkAllPSPegawaiNotificationsAsRead,
} from 'api/kinerja/pengawas-sekolah/notification'
import CardNotificationBase from 'app/KinerjaPSPegawaiPage/components/CardNotification/CardNotificationBase'
import CardNotificationPelaksanaanAppealPS from 'app/KinerjaPSPegawaiPage/components/CardNotification/CardNotificationPelaksanaanAppealPS'
import CardNotificationPelaksanaanAppealApprovedPS from 'app/KinerjaPSPegawaiPage/components/CardNotification/CardNotificationPelaksanaanAppealApprovedPS'
import CardNotificationPenilaianPeriodik from 'app/KinerjaPSPegawaiPage/components/CardNotification/CardNotificationPenilaianPeriodik'
import CardNotificationRotasiMutasiPS from 'app/KinerjaPSPegawaiPage/components/CardNotification/CardNotificationRotasiMutasiPS'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { GeneralNoticeState } from 'components/NoticeState'
import { assetUrl } from 'utils/url'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

function KinerjaPSPegawaiNotifikasiIndex() {
  const { isPegawaiPengawasSekolah } = useRoleContext()

  const {
    data: dataNotificationList,
    isLoading,
    isSuccess: isSuccessNotificationList,
  } = useAPIGetPSPegawaiNotificationList()

  const markAllNotificationAsReadMutation =
    useAPIMarkAllPSPegawaiNotificationsAsRead()

  const activeMenu = React.useMemo(() => {
    if (isPegawaiPengawasSekolah) {
      return 'notifikasi-ps-pegawai'
    }

    return 'notifikasi-ps-tim-kinerja'
  }, [isPegawaiPengawasSekolah])

  React.useEffect(() => {
    if (isSuccessNotificationList) {
      markAllNotificationAsReadMutation.mutate({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessNotificationList])

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu={activeMenu} />

      <main className="py-8 pl-5 pr-8 space-y-4">
        {isLoading &&
          Array.from(Array(5).keys()).map((key) => (
            <Shimmer key={`shimmer-${key}`} width="100%" height="160px" />
          ))}

        {isSuccessNotificationList &&
          !isLoading &&
          dataNotificationList?.data?.length <= 0 && (
            <GeneralNoticeState
              containerClassNames="flex flex-col items-center justify-center mt-16"
              icon={
                <img
                  src={assetUrl('/illustrations/img-empty-document-2.png')}
                  alt=""
                  width="84"
                  height="84"
                />
              }
              title="Belum ada notifikasi"
              titleClassNames="!mt-3"
              description="Semua notifikasi sudah terbaca atau belum ada notifikasi baru. Mari cek yang lain?"
              descriptionClassNames="!mt-1"
            />
          )}
        {dataNotificationList?.data?.map((notificationItem) => {
          const notificationCardProps = {
            key: notificationItem.id,
            date: notificationItem.date,
            description: notificationItem.description,
            title: notificationItem.title,
          }

          switch (notificationItem.type) {
            case 'EDIT_FORM_REQUEST':
              return (
                <CardNotificationPelaksanaanAppealPS
                  key={notificationItem.id}
                  appealState={notificationItem.results?.confirmationState}
                  editState={notificationItem.contents?.perubahanStatus}
                  currentState={notificationItem.contents?.pelaksanaanStatus}
                  date={notificationItem.date}
                  description={notificationItem.description}
                  notificationId={notificationItem.id}
                  title={notificationItem.title}
                  skpId={notificationItem.skpId}
                  name={
                    notificationItem.contents?.namaPengawas ||
                    'Pengawas Sekolah'
                  }
                />
              )
            case 'EDIT_FORM_REQUEST_APPROVED':
              return (
                <CardNotificationPelaksanaanAppealApprovedPS
                  {...notificationCardProps}
                />
              )
            case 'PENILAIAN_PERIODIK_FOR_PPK':
              return (
                <CardNotificationPenilaianPeriodik {...notificationCardProps} />
              )
            case 'ROTASI_MUTASI_PS':
              return (
                <CardNotificationRotasiMutasiPS {...notificationCardProps} />
              )
            default:
              return (
                <CardNotificationBase
                  data-type={notificationItem.type}
                  {...notificationCardProps}
                />
              )
          }
        })}
      </main>
    </div>
  )
}

export default KinerjaPSPegawaiNotifikasiIndex
